import APIClient, { ErrorCode } from '@/api/APIClient'
import { networkErrorItem, apiErrorItem, nonErrorItem } from '../api/APIClient'

export const UPPER_LIMIT_STATUS = {
  NONE: 'NONE',
  UPPER_LIMIT_OVER: 'UPPER_LIMIT_OVER',
  UPPER_LIMIT_OVER_ON_CAMPAIGN: 'UPPER_LIMIT_OVER_ON_CAMPAIGN'
}

export class InvitationData {
  constructor(data) {
    this.title = data.title
    this.description = data.description
    this.invitation_url = data.invitation_url
    this.invitee_expire_at = data.invitee_expire_at
    this.invitee_point = data.invitee_point
    this.invitation_uuid = data.invitation_uuid
  }
}

const initialState = () => ({
  invitationData: null,
  errorItem: null,
  upperLimitStatus: UPPER_LIMIT_STATUS.NONE
})

export const Invitation = {
  namespaced: true,
  state: initialState,
  getters: {
    invitationData: state => state.invitationData,
    upperLimitStatus: state => state.upperLimitStatus,
    errorItem: state => state.errorItem
  },
  mutations: {
    SET_INVITATION_DATA(state, payload) {
      state.invitationData = new InvitationData(payload)
    },
    UPDATE_UPPER_LIMIT_STATUS(state, code) {
      if (code === ErrorCode.CODE_INVITATION_UPPER_LIMIT) {
        state.upperLimitStatus = UPPER_LIMIT_STATUS.UPPER_LIMIT_OVER
      } else if (code === ErrorCode.CODE_INVITATION_UPPER_LIMIT_CAMPAIGN) {
        state.upperLimitStatus = UPPER_LIMIT_STATUS.UPPER_LIMIT_OVER_ON_CAMPAIGN
      } else {
        state.upperLimitStatus = UPPER_LIMIT_STATUS.NONE
      }
    },
    CLEAR_UPPER_LIMIT_STATUS(state) {
      state.upperLimitStatus = UPPER_LIMIT_STATUS.NONE
    },
    OCCUR_API_ERROR(state, res) {
      if (res == null) {
        state.errorItem = networkErrorItem()
      } else {
        state.errorItem = apiErrorItem(res)
      }
    },
    CLEAR_API_ERROR(state) {
      state.errorItem = nonErrorItem()
    }
  },
  actions: {
    /**
     * お友だち紹介を開始する
     * @param commit
     * @param payload
     * @param {String} payload.app_token
     * @param {String} payload.acc_time
     * @param {String} payload.user_id
     * @param {String} payload.client_id
     */
    async actionSendRegisterInvitation({ commit }, payload) {
      const token = payload.app_token
      const userId = payload.user_id
      const clientId = payload.client_id
      try {
        let res = await APIClient.postRegisterInvitation(
          token, payload.acc_time, userId, clientId
        )
        if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
          commit('SET_INVITATION_DATA', res.data.data.invitation_data)
        } else if (res.data.data.code === ErrorCode.CODE_INVITATION_UPPER_LIMIT || res.data.data.code === ErrorCode.CODE_INVITATION_UPPER_LIMIT_CAMPAIGN) {
          commit('UPDATE_UPPER_LIMIT_STATUS', res.data.data.code)
        } else {
          commit('OCCUR_API_ERROR', res)
        }
      } catch (e) {
        commit('OCCUR_API_ERROR', null)
      }
    },

    /**
     * 上限エラーをNoneに戻す
     * @param commit
     */
    actionClearUpperLimit({ commit }) {
      commit('CLEAR_UPPER_LIMIT_STATUS')
    },

    /**
     * ネットワークエラー状態をOFFに戻す
     * @param commit
     */
    actionClearAPIError({ commit }) {
      commit('CLEAR_API_ERROR')
    }
  }
}
